module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"สามารถเข้าถึงข้อมูลของ","page.description":"แสดงและค้นหาศูนย์บริการของ Tiger Drone","confirm.action.update":"ยืนยันการแก้ไขข้อมูล","action.update.no_change":"ไม่ได้มีการแก้ไขค่า","action.update.success":"บันทึกสำเร็จ","confirm.action.update.content":"คุณต้องการบันทึกการแก้ไขข้อมูลหรือไม่ ?"}}')
  delete Component.options._Ctor
}
